import Header from './components/header'
import Footer from './components/footer'

export default function Layout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />

      {/* Mobile query */}
      <style jsx>{`
        @media (max-width: 1024px) {
          html {
            scroll-padding-top: 5.5rem;
          }

          button {
            outline: none;
          }
        }
      `}</style>
    </>
  )
}
